import { PAGE_ROUTES } from '@/components/nav/utils/url-builders';
import { useInboxContext } from '@/contexts/inbox-provider';
import { isPageActive } from '@/lib/is-page-active';
import { dealStore, notificationStore, userStore } from '@/models/stores';
import { useEffect } from 'react';

const useInboxPageHydrateLocal = () => {
  const { isInboxView } = useInboxContext();
  const isInboxPageActive = isPageActive(PAGE_ROUTES.INBOX) || isInboxView;

  useEffect(() => {
    if (!isInboxPageActive) {
      return;
    }

    // Dev note: this needs to handles archived deals
    // which can cause infinite loops
    // And we have to handle how the route shows /deal/ when a notification is open
    const hydrateInbox = async () => {
      await Promise.all([
        notificationStore.hydrateLocal(),
        dealStore.hydrateActiveDeals(),
        userStore.hydrateLocal(),
      ]);
    };

    hydrateInbox();
  }, [isInboxPageActive]);
};

export default useInboxPageHydrateLocal;
